var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nurse-table',{attrs:{"canDelete":true,"viewRoute":"AdminNurseDetails","canCreate":true,"viewDetailRoute":"SubAdminNurseDetail","createRoute":"AdminNurseCreate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }